var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSlowLaunchCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slow_BG_-Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6131 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        opacity: .2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1687.5,
    x2: 6131,
    y2: 1687.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1575,
    x2: 6131,
    y2: 1575
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1462.5,
    x2: 6131,
    y2: 1462.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1350,
    x2: 6131,
    y2: 1350
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1237.5,
    x2: 6131,
    y2: 1237.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1125,
    x2: 6131,
    y2: 1125
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1012.5,
    x2: 6131,
    y2: 1012.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 900,
    x2: 6131,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 787.5,
    x2: 6131,
    y2: 787.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 675,
    x2: 6131,
    y2: 675
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 562.5,
    x2: 6131,
    y2: 562.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 450,
    x2: 6131,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 337.5,
    x2: 6131,
    y2: 337.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 225,
    x2: 6131,
    y2: 225
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 112.5,
    x2: 6131,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6010.78,
    x2: 6010.78,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5890.57,
    x2: 5890.57,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5770.35,
    x2: 5770.35,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5650.14,
    x2: 5650.14,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5529.92,
    x2: 5529.92,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5409.71,
    x2: 5409.71,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5289.49,
    x2: 5289.49,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5169.27,
    x2: 5169.27,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5049.06,
    x2: 5049.06,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4928.84,
    x2: 4928.84,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4808.63,
    x2: 4808.63,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4688.41,
    x2: 4688.41,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4568.2,
    x2: 4568.2,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4447.98,
    x2: 4447.98,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4327.76,
    x2: 4327.76,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4207.55,
    x2: 4207.55,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4087.33,
    x2: 4087.33,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3967.12,
    x2: 3967.12,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3846.9,
    x2: 3846.9,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3726.69,
    x2: 3726.69,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3606.47,
    x2: 3606.47,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3486.25,
    x2: 3486.25,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3366.04,
    x2: 3366.04,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3245.82,
    x2: 3245.82,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3125.61,
    x2: 3125.61,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3005.39,
    x2: 3005.39,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2885.18,
    x2: 2885.18,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2764.96,
    x2: 2764.96,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2644.75,
    x2: 2644.75,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2524.53,
    x2: 2524.53,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2404.31,
    x2: 2404.31,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2284.1,
    x2: 2284.1,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2163.88,
    x2: 2163.88,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2043.67,
    x2: 2043.67,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1923.45,
    x2: 1923.45,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1803.24,
    x2: 1803.24,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1683.02,
    x2: 1683.02,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1562.8,
    x2: 1562.8,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1442.59,
    x2: 1442.59,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1322.37,
    x2: 1322.37,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1202.16,
    x2: 1202.16,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1081.94,
    x2: 1081.94,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 961.73,
    x2: 961.73,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 841.51,
    x2: 841.51,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 721.29,
    x2: 721.29,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 601.08,
    x2: 601.08,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 480.86,
    x2: 480.86,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 360.65,
    x2: 360.65,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 240.43,
    x2: 240.43,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 120.22,
    x2: 120.22,
    y2: 1800
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSlowLaunchCheck);
export default __webpack_public_path__ + "static/media/bg-slow-launch-check.d2eed810b9b758bc46f14ae57ea113ef.svg";
export { ForwardRef as ReactComponent };